/** Persist new-calendar choices; legacy sources keep their existing colors. */
export const CALENDAR_SOURCE_COLORS = [
  '#2f80ed',
  '#27ae60',
  '#f2994a',
  '#eb5757',
  '#9b51e0',
  '#00a3a3',
  '#56ccf2',
  '#6fcf97',
  '#f2c94c',
  '#f97316',
  '#ec4899',
  '#c026d3',
  '#6366f1',
  '#8b5cf6',
  '#84cc16',
  '#64748b',
] as const;

export function randomCalendarSourceColor(random = Math.random): string {
  return (
    CALENDAR_SOURCE_COLORS[
      Math.floor(random() * CALENDAR_SOURCE_COLORS.length)
    ] ?? CALENDAR_SOURCE_COLORS[0]
  );
}
